import React, { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import PieChart from "./components/PieChart";
import LineChart from "./components/LineChart";

function Chartjs({ Data, type }) {
  return (
    /* {<div style={{height: "60vh", width: "100%"}}>
			{/* <PieChart chartData={chartData} /> }
      {/* <LineChart chartData={chartData} /> }
      
		</div>} */

    <LineChart chartData={Data} />
  );
}

export default Chartjs;
